"use strict";
import { nativeOnChain } from "constants/tokens";
import { useMemo } from "react";
import { UniverseChainId } from "uniswap/src/types/chains";
export default function useNativeCurrency(chainId) {
  return useMemo(
    () => chainId ? nativeOnChain(chainId) : (
      // display mainnet when not connected
      nativeOnChain(UniverseChainId.Mainnet)
    ),
    [chainId]
  );
}
